import { FunctionComponent, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from '../../util/api.util';
import { mapSignupFormValuesToRegisterPayload } from '../../util/setup.util';
import { useAsyncEffect, useToaster } from '../../hooks';
import { FullPageLoader } from '../../components';
import { coreapi } from '../../api';
import { history } from '../../history';
import { AuthStore, updateAuth } from '../../context';

export const SetupPage: FunctionComponent = () => {
  const { search } = useLocation();
  const { toaster, toast } = useToaster();
  const { dispatch } = useContext(AuthStore);

  useAsyncEffect(async () => {
    const formValues = parse(search);
    const payload = mapSignupFormValuesToRegisterPayload(formValues);

    try {
      const res = await coreapi.post(null!, '/register', payload, res => res);

      if (res.status === 200) {
        // 200 means this is a new user and an auth set was returned
        dispatch(updateAuth(res.data));

        // handle redirect to gogurt if registration_source is 'gogurt'
        if (payload.registration_source === 'gogurt') {
          history.replace('/sign-up');
        } else {
          history.replace('/welcome');
        }
      } else {
        // anything other than a 200 means this is an existing user
        // and an auth set was /not/ returned
        history.replace(
          `/magiclink/sent?email=${encodeURIComponent(payload.email!)}`,
        );
      }
    } catch (error) {
      toaster(
        toast.error(error, 'There was a problem creating your account.', {
          lifetime: 'forever',
        }),
      );
    }
  }, [search]);

  return <FullPageLoader id="setup-page-loader" />;
};
